
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type CategoryPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function CategoryPageRT(): TemplateResult<CategoryPageRTRootProps> {
    return _createElement('div', { 'className': 'clear-self cm_SearchPage' }, [this.CategoryVehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '11391'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '11394'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3361'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3563'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': 'mr-0 ' + this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '43'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select h-100 border-0 shadow-none text-secondary p-3 pr-5',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2623'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__category mb-5 bg-light cm_CategoryVehicleWidget' }, this.template === 'active' ? _createElement('div', {
                'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
                'key': '98'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn-primary',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn-secondary',
                'onClick': this.discardVehicle,
                'disabled': !this.allowToDiscardVehicle,
                'role': 'button',
                'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
            }, [_createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'className': 'cm_icon cm_icon-reset',
                    'height': '16px',
                    'viewBox': '0 0 16 16',
                    'key': '67540'
                }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cm_vehicle-widget_label cmTemplate_locked',
                'key': '7275'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n  ', this.vehicleString, '\n  ', _createElement('span', { 'className': 'cm_vehicle-widget_subtitle' }, this.fitmentSearchTitle)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__change btn btn-primary',
                'onClick': this.openDialog
            }, '\n      ', _translate(`ymm_bar_change`), '\n    '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__discard btn btn-secondary',
                'onClick': this.discardVehicle
            }, [_createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'className': 'cm_icon cm_icon-reset',
                    'height': '16px',
                    'viewBox': '0 0 16 16',
                    'key': '79090'
                }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.FacetBarWheels(function () {
            function repeatSelects1(facet_bar_label, selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '12491'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '12494'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3471'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3673'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': 'cmTemplate_selectFacet' }, _createElement('div', { 'className': 'cm_vehicle-widget_select' }, [_createElement('div', {
                                'className': 'mr-0 ' + this.extraClassName,
                                'key': '980'
                            }, !this.isSearchable ? _createElement('div', {
                                'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                'key': '153'
                            }, _createElement('select', {
                                'className': 'cm_select_inner-select h-100 border-0 shadow-none text-secondary p-3 pr-5',
                                'onChange': this.onChange,
                                'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                'disabled': this.disabled,
                                'aria-label': this.title
                            }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                        return _createElement('div', { 'className': 'cm_filterInput' });
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                'div',
                                {
                                    'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                    'aria-label': this.title,
                                    'key': '2733'
                                },
                                !this.hideNullOption ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'onClick': () => this.onChange('')
                                }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                this.loading ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                            ]) : null)]));
                    }, { count: undefined })];
            }
            function scopeFacet_bar_label2() {
                var facet_bar_label = _translate(`wheels_panel_label`);
                return _createElement('div', { 'className': 'mb-5 bg-light position-relative cm_FacetBarWheels' }, _createElement('div', { 'className': 'cm_FacetBarWheelsTires cm_facets' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__facet-bar' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns flex-md-row align-items-md-center p-3' }, _createElement('div', { 'className': 'cm_vehicle-widget_title d-md-flex flex-column text-center text-uppercase pl-md-3 pr-md-4 mr-0' }, facet_bar_label), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container cmRepeater_facets cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this, facet_bar_label))
                ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn-secondary',
                    'onClick': this.discardFields,
                    'disabled': !this.hasSelection,
                    'role': 'button',
                    'tabIndex': this.hasSelection ? '0' : '-1'
                }, [_createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'className': 'cm_icon cm_icon-reset',
                        'height': '16px',
                        'viewBox': '0 0 16 16',
                        'key': '68620'
                    }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))))));
            }
            return scopeFacet_bar_label2.apply(this, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.FacetBarTires(function () {
            function repeatSelects1(facet_bar_label, selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '12491'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '12494'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3471'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3673'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': 'cmTemplate_selectFacet' }, _createElement('div', { 'className': 'cm_vehicle-widget_select' }, [_createElement('div', {
                                'className': 'mr-0 ' + this.extraClassName,
                                'key': '980'
                            }, !this.isSearchable ? _createElement('div', {
                                'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                'key': '153'
                            }, _createElement('select', {
                                'className': 'cm_select_inner-select h-100 border-0 shadow-none text-secondary p-3 pr-5',
                                'onChange': this.onChange,
                                'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                'disabled': this.disabled,
                                'aria-label': this.title
                            }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                        return _createElement('div', { 'className': 'cm_filterInput' });
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                'div',
                                {
                                    'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                    'aria-label': this.title,
                                    'key': '2733'
                                },
                                !this.hideNullOption ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'onClick': () => this.onChange('')
                                }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                this.loading ? _createElement('div', {
                                    'className': 'option',
                                    'key': 'null-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                            ]) : null)]));
                    }, { count: undefined })];
            }
            function scopeFacet_bar_label2() {
                var facet_bar_label = _translate(`tires_panel_label`);
                return _createElement('div', { 'className': 'mb-5 bg-light position-relative cm_FacetBarTires' }, _createElement('div', { 'className': 'cm_FacetBarWheelsTires cm_facets' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__facet-bar' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns flex-md-row align-items-md-center p-3' }, _createElement('div', { 'className': 'cm_vehicle-widget_title d-md-flex flex-column text-center text-uppercase pl-md-3 pr-md-4 mr-0' }, facet_bar_label), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container cmRepeater_facets cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this, facet_bar_label))
                ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn-secondary',
                    'onClick': this.discardFields,
                    'disabled': !this.hasSelection,
                    'role': 'button',
                    'tabIndex': this.hasSelection ? '0' : '-1'
                }, [_createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'className': 'cm_icon cm_icon-reset',
                        'height': '16px',
                        'viewBox': '0 0 16 16',
                        'key': '68600'
                    }, _createElement('path', { 'd': 'M2.083,9H0.062H0v5l1.481-1.361C2.932,14.673,5.311,16,8,16c4.08,0,7.446-3.054,7.938-7h-2.021 c-0.476,2.838-2.944,5-5.917,5c-2.106,0-3.96-1.086-5.03-2.729L5.441,9H2.083z' }), _createElement('path', { 'd': 'M8,0C3.92,0,0.554,3.054,0.062,7h2.021C2.559,4.162,5.027,2,8,2c2.169,0,4.07,1.151,5.124,2.876 L11,7h2h0.917h2.021H16V2l-1.432,1.432C13.123,1.357,10.72,0,8,0z' }))])))))));
            }
            return scopeFacet_bar_label2.apply(this, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.FacetPanel(function () {
            return _createElement('div', { 'className': 'cm_FacetPanel' }, [[this.filterChips(function () {
                        function repeatChips1(chips, chipsIndex) {
                            return [chips(function () {
                                    function repeatI1_reviewChip(i, iIndex) {
                                        return _createElement('span', {
                                            'key': `${ this.field }|${ i }`,
                                            'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                        });
                                    }
                                    return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name === 'query' ? _translate(`current_query_label`) : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '3500'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                        'a',
                                        {
                                            'className': 'facetentrykey',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        },
                                        _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                        _map([
                                            0,
                                            1,
                                            2,
                                            3,
                                            4
                                        ], repeatI1_reviewChip.bind(this)),
                                        this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                    ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '4900'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_range_delimiter`),
                                        ' ',
                                        this.selectedRange[1]
                                    ] : null, this.toPosInf ? [
                                        this.selectedRange[0],
                                        ' ',
                                        _translate(`ranged_facet_more`)
                                    ] : null, this.toNegInf ? [
                                        this.selectedRange[1],
                                        ' ',
                                        _translate(`ranged_facet_less`)
                                    ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '5360'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                            'className': 'facettitle',
                            'tabIndex': '0'
                        }, _translate(`selected_facets_label`)), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                            'div',
                            {
                                'role': 'list',
                                'className': 'cmRepeater_chips'
                            },
                            _map(this.chips, repeatChips1.bind(this))
                        ]), _createElement('div', {
                            'className': 'btn btn-outline-primary btn btn-secondary cm_filter-chips_button',
                            'data-cm-role': 'start-over'
                        }, '\n        ', _translate(`selected_facets_clear`), '\n      '))));
                    }, {
                        widgetName: 'filter-chips',
                        items: undefined
                    })]], [this.facets(function () {
                    function repeatFacets1(facets, facetsIndex) {
                        return [facets(function () {
                                function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                    return [ShowAlwaysValues(function () {
                                            return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                'type': 'checkbox',
                                                'className': 'cm_facet_checkbox',
                                                'readOnly': true,
                                                'checked': this.isSelected
                                            }), _createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem'
                                            }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                        }, { count: undefined })];
                                }
                                function repeatValues2(Values, ValuesIndex) {
                                    return [Values(function () {
                                            return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                'type': 'checkbox',
                                                'className': 'cm_facet_checkbox',
                                                'readOnly': true,
                                                'checked': this.isSelected
                                            }), _createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem'
                                            }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                        }, { count: undefined })];
                                }
                                function repeatValues3(Values, ValuesIndex) {
                                    return [Values(function () {
                                            return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                'type': 'checkbox',
                                                'className': 'cm_facet_checkbox',
                                                'readOnly': true,
                                                'checked': this.isSelected
                                            }), !this.isCustomRange ? [
                                                _createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem',
                                                    'key': '1541'
                                                }, _createElement('span', {}, this.value)),
                                                _createElement('div', {
                                                    'className': 'facetentryval',
                                                    'key': '1543'
                                                }, this.hitCount)
                                            ] : null, this.isCustomRange ? [_createElement('a', {
                                                    'className': 'facetentrykey',
                                                    'tabIndex': '0',
                                                    'role': 'listitem',
                                                    'key': '3901'
                                                }, this.finite ? _createElement('span', { 'key': '503' }, this.range[0], ' - ', this.range[1]) : null, this.toPosInf ? _createElement('span', { 'key': '580' }, this.range[0], ' ', _translate(`ranged_facet_more`)) : null, this.toNegInf ? _createElement('span', { 'key': '676' }, this.range[1], ' ', _translate(`ranged_facet_less`)) : null)] : null);
                                        }, { count: undefined })];
                                }
                                function repeatShowAlwaysValues4(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                    return [ShowAlwaysValues(function () {
                                            function scopeStarFill1(i, iIndex) {
                                                var starFill = this.value - i;
                                                return _createElement('span', {
                                                    'key': i,
                                                    'className': 'cm_star cm_star__' + (starFill < 0.25 ? 'empty' : starFill < 0.75 ? 'half' : 'full')
                                                });
                                            }
                                            function repeatI2(i, iIndex, starFill) {
                                                return scopeStarFill1.apply(this, [
                                                    i,
                                                    iIndex
                                                ]);
                                            }
                                            return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                'type': 'checkbox',
                                                'className': 'cm_facet_checkbox',
                                                'readOnly': true,
                                                'checked': this.isSelected
                                            }), _createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem'
                                            }, _createElement.apply(this, [
                                                'span',
                                                { 'className': 'cm_review-stars' },
                                                _map([
                                                    0,
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ], repeatI2.bind(this))
                                            ]), this.value !== '5' ? _createElement('span', {
                                                'className': 'cm_and-up',
                                                'key': '499'
                                            }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                        }, { count: undefined })];
                                }
                                function repeatValues5(Values, ValuesIndex) {
                                    return [Values(function () {
                                            function scopeStarFill1(i, iIndex) {
                                                var starFill = this.value - i;
                                                return _createElement('span', {
                                                    'key': i,
                                                    'className': 'cm_star cm_star__' + (starFill < 0.25 ? 'empty' : starFill < 0.75 ? 'half' : 'full')
                                                });
                                            }
                                            function repeatI2(i, iIndex, starFill) {
                                                return scopeStarFill1.apply(this, [
                                                    i,
                                                    iIndex
                                                ]);
                                            }
                                            return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                                'type': 'checkbox',
                                                'className': 'cm_facet_checkbox',
                                                'readOnly': true,
                                                'checked': this.isSelected
                                            }), _createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem'
                                            }, _createElement.apply(this, [
                                                'span',
                                                { 'className': 'cm_review-stars' },
                                                _map([
                                                    0,
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ], repeatI2.bind(this))
                                            ]), this.value !== '5' ? _createElement('span', {
                                                'className': 'cm_and-up',
                                                'key': '499'
                                            }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                        }, { count: undefined })];
                                }
                                return !window.Convermax.facetPanelIgnoreField(this.field) ? _createElement('div', {
                                    'className': 'facetholder cm_field-' + this.field,
                                    'key': '3'
                                }, _createElement('div', {
                                    'className': 'facettitle',
                                    'data-cm-role': 'toggle-facet',
                                    'tabIndex': '0'
                                }, _createElement('span', {}, this.name), this.isCollapsed ? [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-angle left',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '39 30 565 565',
                                        'aria-hidden': 'true',
                                        'key': '2180'
                                    }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null, !this.isCollapsed ? [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-angle down',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '39 30 565 565',
                                        'aria-hidden': 'true',
                                        'key': '5410'
                                    }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))] : null), _createElement('div', {
                                    'className': 'facetbody' + (this.template === 'simpleFacet' && this.needShowMore && !this.moreValuesToShow ? ' expanded' : ''),
                                    'role': 'list'
                                }, this.template === 'simpleFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_simpleFacet',
                                    'key': '1061'
                                }, this.showFilterInput ? _createElement('div', {
                                    'className': 'filter-input',
                                    'key': '1147'
                                }, [this.filterInput(function () {
                                        return _createElement('div', {
                                            'className': 'input  cm_filterInput',
                                            'placeholder': _translate(`facet_filter_placeholder`)
                                        });
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })], this.inputNotEmpty ? _createElement('span', {
                                    'className': 'filter-input_clear-container',
                                    'onClick': this.clearInput,
                                    'key': '1486'
                                }, _createElement('span', { 'className': 'filter-input_clear' }, '\u2715')) : null) : null, !this.ShowAlwaysValues.length && !this.Values.length ? [_createElement('div', {
                                        'className': 'facetdiv',
                                        'key': '16551'
                                    }, _createElement('span', { 'className': 'facetentrykey' }, _translate(`facet_filter_nothing`)))] : null, _createElement('div', { 'className': 'facetvalues' + (this.showFilterInput && !this.moreValuesToShow ? ' overflowed' : '') }, _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_ShowAlwaysValues' },
                                    _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                                ]), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_Values' },
                                    _map(this.Values, repeatValues2.bind(this))
                                ]), this.needShowMore ? _createElement('div', {
                                    'className': 'facetdiv cm_show-all-container',
                                    'key': '3467'
                                }, _createElement('a', {
                                    'className': 'cm_show-all',
                                    'data-cm-role': 'toggle-show-more',
                                    'tabIndex': '0'
                                }, this.moreValuesToShow ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.moreValuesToShow ? [_translate(`show_less`)] : null)) : null)) : null, this.template === 'priceFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_priceFacet',
                                    'key': '3844'
                                }, !this.ranges.length ? [
                                    _createElement('div', { 'key': '39281' }, this.selectedRawRange[0], ' ', _translate(`ranged_facet_range_delimiter`), ' ', this.selectedRawRange[1]),
                                    '\n  ',
                                    this.slider,
                                    '\n  ',
                                    _createElement('div', {
                                        'className': 'cm_flex',
                                        'key': '39283'
                                    }, _createElement('div', { 'className': 'cm_flex-grow' }, _translate(`ranged_facet_min`), ' ', this.rawMin), _createElement('div', {}, _translate(`ranged_facet_max`), ' ', this.rawMax))
                                ] : null, this.ranges.length ? [_createElement.apply(this, [
                                        'div',
                                        {
                                            'className': 'cmRepeater_Values',
                                            'key': '42931'
                                        },
                                        _map(this.Values, repeatValues3.bind(this))
                                    ])] : null, [this.Inputs(function () {
                                        return _createElement('div', { 'className': 'input cm_Inputs' }, [this.inputMin(function () {
                                                return _createElement('div', {
                                                    'placeholder': _translate(`ranged_facet_min`),
                                                    'className': 'cm_inputMin'
                                                });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })], _createElement('span', { 'className': 'separator' }, _translate(`ranged_facet_inputs_delimiter`)), [this.inputMax(function () {
                                                return _createElement('div', {
                                                    'placeholder': _translate(`ranged_facet_max`),
                                                    'className': 'cm_inputMax'
                                                });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })], _createElement('button', {
                                            'type': 'button',
                                            'className': 'btn btn-outline-primary btn btn-secondary',
                                            'onClick': this.setCustomRange
                                        }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null, this.template === 'selectFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_selectFacet',
                                    'key': '6972'
                                }, [this.select(function () {
                                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                            return _createElement('option', {
                                                'disabled': this.loading,
                                                'value': entry.term,
                                                'key': entry.value
                                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                                        }
                                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                            return _createElement('option', {
                                                'disabled': this.loading,
                                                'value': entry.term,
                                                'key': entry.value
                                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                                        }
                                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                            var isPopularField = popularEntries.length && unpopularEntries.length;
                                            return [
                                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                                    'value': '',
                                                    'key': 'null-option'
                                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                                this.loading ? _createElement('option', {
                                                    'key': 'loading-option',
                                                    'disabled': true
                                                }, _translate(`select_loading`)) : null,
                                                isPopularField ? [
                                                    _createElement('option', {
                                                        'className': 'cm_option_title cm_option-popular',
                                                        'disabled': true,
                                                        'key': '11621'
                                                    }, _translate(`ymm_bar_popular`)),
                                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                                    _createElement('option', {
                                                        'className': 'cm_option_title cm_option-unpopular',
                                                        'disabled': true,
                                                        'key': '11624'
                                                    }, _translate(`ymm_bar_unpopular`))
                                                ] : null,
                                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                            ];
                                        }
                                        function scopeShowSelectedValues4() {
                                            var showSelectedValues = this.selectedEntries.length;
                                            return _createElement('option', {
                                                'key': '_current',
                                                'value': '_current'
                                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                                _translate(`select_title`),
                                                ' ',
                                                this.title
                                            ] : null);
                                        }
                                        function repeatEntry5(entry, index) {
                                            return _createElement('div', {
                                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                                'key': entry.value,
                                                'onClick': () => this.onChange(entry.term)
                                            }, this.showCheckboxes ? _createElement('input', {
                                                'type': 'checkbox',
                                                'readOnly': true,
                                                'checked': entry.selected,
                                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                                'key': '3384'
                                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                                'className': 'cm_dropdown_hitCount',
                                                'key': '3586'
                                            }, entry.hitCount) : null);
                                        }
                                        return _createElement('div', { 'className': 'cm_select' }, _createElement('div', { 'className': 'mr-0 ' + this.extraClassName }, !this.isSearchable ? _createElement('div', {
                                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                            'key': '66'
                                        }, _createElement('select', {
                                            'className': 'cm_select_inner-select h-100 border-0 shadow-none text-secondary p-3 pr-5',
                                            'onChange': this.onChange,
                                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                            'disabled': this.disabled,
                                            'aria-label': this.title
                                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                            'div',
                                            {
                                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                                'aria-label': this.title,
                                                'key': '2646'
                                            },
                                            !this.hideNullOption ? _createElement('div', {
                                                'className': 'option',
                                                'key': 'null-option',
                                                'onClick': () => this.onChange('')
                                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                            this.loading ? _createElement('div', {
                                                'className': 'option',
                                                'key': 'null-option',
                                                'disabled': true
                                            }, _translate(`select_loading`)) : null,
                                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                        ]) : null));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null, this.template === 'reviewFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_reviewFacet',
                                    'key': '12876'
                                }, _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_ShowAlwaysValues' },
                                    _map(this.ShowAlwaysValues, repeatShowAlwaysValues4.bind(this))
                                ]), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_Values' },
                                    _map(this.Values, repeatValues5.bind(this))
                                ])) : null, this.template === 'sliderFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_sliderFacet',
                                    'key': '15925'
                                }, _createElement('div', { 'className': 'facetslider' }, _createElement('div', { 'className': 'facetsliderinfo' }, '\n    ', _translate(`ranged_facet_selected_label`), ' ', this.selectedRange[0], ' ', _translate(`ranged_facet_range_delimiter`), '\n    ', this.selectedRange[1], '\n  '), '\n  ', this.slider, '\n  ', _createElement('div', { 'className': 'cm_slider-bounds' }, _createElement('div', { 'className': 'min' }, this.min), _createElement('div', { 'className': 'max' }, this.max), _createElement('div', { 'className': 'clear' }))), [this.Inputs(function () {
                                        return _createElement('div', { 'className': 'input cm_Inputs' }, this.inputMin ? [[this.inputMin(function () {
                                                    return _createElement('div', {
                                                        'placeholder': _translate(`ranged_facet_min`),
                                                        'className': 'cm_inputMin'
                                                    });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, this.inputMin && this.inputMax ? _createElement('span', {
                                            'className': 'separator',
                                            'key': '347'
                                        }, _translate(`ranged_facet_inputs_delimiter`)) : null, this.inputMax ? [[this.inputMax(function () {
                                                    return _createElement('div', {
                                                        'placeholder': _translate(`ranged_facet_max`),
                                                        'className': 'cm_inputMax'
                                                    });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, _createElement('button', {
                                            'type': 'button',
                                            'className': 'btn btn-outline-primary btn btn-secondary',
                                            'onClick': this.setCustomRange
                                        }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null)) : null;
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cmRepeater_facets' },
                        _map(this.facets, repeatFacets1.bind(this))
                    ]));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement('div', { 'className': 'cm_main-content' }, _createElement('div', { 'id': 'itemsBlock' }, [this.message(function () {
            return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                    'href': 'mailto:support@convermax.com',
                    'className': 'cm_message-link'
                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                    'className': 'cm_message__incompatible',
                    'key': '8800'
                }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                    'className': 'cm_message__nothing-for-vehicle',
                    'key': '10670'
                }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'href': this.searchByVehicleUrl
                }, _translate(`message_view_compatible_products`)))] : null, this.universalFitResults ? [_createElement('div', {
                    'className': 'cm_message__universal-results',
                    'key': '13900'
                }, _translate(`message_universal_fit_results`))] : null, this.template === 'badRequest' ? _createElement('div', {
                'className': 'cmTemplate_badRequest',
                'key': '1545'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver
            }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '18340' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '19210' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '20040' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '17974' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                'className': 'cmTemplate_corrected',
                'key': '2167'
            }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                originalQuery: this.
                originalQuery, 
                query
            : this.
                query
             }))) : null, this.template === 'networkError' ? _createElement('div', {
                'className': 'cmTemplate_networkError',
                'key': '2334'
            }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '25160' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '26030' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '26860' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '24794' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                'className': 'cmTemplate_nothing',
                'key': '2849'
            }, _createElement('div', {}, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver,
                'key': '2973'
            }, _translate(`message_reset_search`)) : null)) : null, this.template === 'partial' ? _createElement('div', {
                'className': 'cmTemplate_partial',
                'key': '3168'
            }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                'className': 'cmTemplate_timeout',
                'key': '3322'
            }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                'className': 'cmTemplate_unknown',
                'key': '3562'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '38410' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '39280' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '40110' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '38044' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.customMessage(function () {
            return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader' }, [this.facetDialogButton(function () {
                    return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                            return _createElement('div', { 'className': 'btn btn-primary cm_dialogButton' }, '\n  ', _translate(`facet_dialog_open_button`), ' \n    ', this.withSelection ? [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '-5 0 394 394.00003',
                                    'key': '950'
                                }, _createElement('path', { 'd': 'm367.82 0h-351.26c-6.1992-0.011719-11.879 3.4492-14.711 8.9609-2.8711 5.5859-2.3672 12.312 1.3008 17.414l128.69 181.29c0.042968 0.0625 0.089843 0.12109 0.13281 0.18359 4.6758 6.3125 7.207 13.961 7.2188 21.816v147.8c-0.027344 4.375 1.6914 8.582 4.7734 11.688 3.0859 3.1016 7.2812 4.8516 11.656 4.8516 2.2227-0.003906 4.4258-0.44531 6.4805-1.3008l72.312-27.57c6.4766-1.9805 10.777-8.0938 10.777-15.453v-120.02c0.011719-7.8555 2.543-15.504 7.2148-21.816 0.042968-0.0625 0.089844-0.12109 0.13281-0.18359l128.69-181.29c3.668-5.0977 4.1719-11.82 1.3008-17.406-2.8281-5.5156-8.5117-8.9766-14.707-8.9648z' }))] : null, !this.withSelection ? [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '0 0 247.46 247.46',
                                    'key': '8360'
                                }, _createElement('path', { 'd': 'm246.74 13.984c-1.238-2.626-3.881-4.301-6.784-4.301h-232.46c-2.903 0-5.545 1.675-6.784 4.301-1.238 2.626-0.85 5.73 0.997 7.97l89.361 108.38v99.94c0 2.595 1.341 5.005 3.545 6.373 1.208 0.749 2.579 1.127 3.955 1.127 1.137 0 2.278-0.259 3.33-0.78l50.208-24.885c2.551-1.264 4.165-3.863 4.169-6.71l0.098-75.062 89.366-108.39c1.848-2.239 2.237-5.344 0.999-7.969zm-103.65 108.89c-1.105 1.34-1.711 3.023-1.713 4.761l-0.096 73.103-35.213 17.453v-90.546c0-1.741-0.605-3.428-1.713-4.771l-80.958-98.191h200.65l-80.958 98.191z' }))] : null);
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('div', {
                'className': 'cm_total-hits',
                'role': 'status'
            }, _createElement('span', {}, this.totalHits, ' ', _translate(`total_products_count_title`))), _createElement('div', { 'className': 'cm_sort sort-by' }, _createElement('span', { 'className': 'sort-label' }, _translate(`sort_select_label`)), '\n  ', this.sortSelect, '\n'));
        }, {
            widgetName: 'search-header',
            items: undefined
        })], [this.SearchResult(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        function mergeProps(inline, external) {
                            var res = Object.assign({}, inline, external);
                            if (inline.hasOwnProperty('style')) {
                                res.style = _.defaults(res.style, inline.style);
                            }
                            if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                res.className = external.className + ' ' + inline.className;
                            }
                            return res;
                        }
                        return _createElement('li', { 'className': 'product text-center px-2 pt-3 pb-4' }, _createElement('div', { 'className': 'product-container d-flex flex-column position-relative' }, _createElement('div', { 'className': 'product-icon-container d-flex position-absolute w-100' }, _createElement('div', { 'className': 'product-badge-container d-flex flex-column' }, window.Convermax.productIsNew(this.published_at) ? _createElement('span', {
                            'className': 'badge product-badge badge-new text-white text-uppercase p-2 mb-1',
                            'key': '338'
                        }, _createElement('span', {}, 'New')) : null, !this.out_of_stock && this.on_sale ? _createElement('span', {
                            'className': 'badge product-badge badge-discount text-white text-uppercase p-2 mb-1',
                            'key': '559'
                        }, _createElement('span', { 'className': 'sr-only' }, 'Discount: '), '\n          -', Math.floor((this.compare_at_price - this.price) / this.compare_at_price * 100), '%\n        ') : null, this.out_of_stock ? _createElement('span', {
                            'className': 'badge product-badge badge-sold-out text-white text-uppercase p-2 mb-1',
                            'key': '895'
                        }, _createElement('span', {}, _translate(`product_out_of_stock`))) : null, !this.out_of_stock && this.stock && (this.stock?.includes('Available') && !this.stock?.includes('In-stock Only')) ? _createElement('span', {
                            'className': 'badge product-badge badge-special-order text-white text-uppercase p-2 mb-1',
                            'key': '1129'
                        }, _createElement('span', {}, 'Special Order')) : null), window.themeSettings.wishlist_enabled === 'true' ? _createElement('form', {
                            'className': 'form-add-product-to-wishlist',
                            'method': 'get',
                            'data-product-handle': this.handle,
                            'data-product-id': this.id,
                            'data-product-title': this.removeHTML(this.title),
                            'data-product-url': this.url,
                            'data-product-featured-image': this.image,
                            'key': '1489'
                        }, _createElement('button', {
                            'type': 'submit',
                            'className': 'wishlist-button-on-image d-flex bg-transparent border-0 shadow-none p-0',
                            'data-original-title': true
                        }, _createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'width': '28',
                            'height': '28',
                            'className': 'icon-heart',
                            'viewBox': '0 0 24 24',
                            'fill': 'none',
                            'stroke': 'none',
                            'strokeWidth': '1',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }, _createElement('path', { 'd': 'M 21.34 2.977 C 19.079 0.384 15.413 0.384 13.152 2.977 L 12.036 4.255 L 10.921 2.977 C 7.769 -0.639 2.388 1.018 1.234 5.951 C 0.699 8.242 1.27 10.685 2.733 12.361 L 3.848 13.643 L 12.036 23.028 L 20.225 13.643 L 21.34 12.361 C 23.602 9.772 23.602 5.566 21.34 2.977 Z' })))) : null), _createElement('div', { 'className': 'product-image-container d-flex justify-content-center align-items-center position-relative ' + (window.themeSettings.img_border === 'true' ? 'img-thumbnail' : 'rounded') }, _createElement('a', {
                            'className': 'product-image d-flex justify-content-center align-items-center',
                            'href': this.url
                        }, _createElement('img', {
                            'className': 'img-fluid',
                            'src': this.imageOrDefault(this.resizeImage(this.image)),
                            'alt': this.removeHTML(this.title),
                            'width': '480',
                            'height': '480',
                            'loading': 'lazy',
                            'onError': this.onImageError
                        })), window.themeSettings.quick_view_enabled === 'true' ? _createElement('div', {
                            'className': 'product-quick-view-btn d-none d-lg-flex align-items-center justify-content-center position-absolute w-100 h-100',
                            'key': '3114'
                        }, _createElement('a', {
                            'className': 'btn-quick-view btn btn-primary btn-skewed py-2 px-3',
                            'data-product-url': this.url,
                            'role': 'button'
                        }, _createElement('span', {
                            'className': 'btn-quick-view-spinner spinner-border spinner-border-sm mr-2 mb-1',
                            'role': 'status',
                            'aria-hidden': 'true',
                            'style': {
                                display: 'none',
                                transform: 'none'
                            }
                        }), _createElement('span', { 'className': 'btn-quick-view-text' }, _translate(`product_quick_view`)))) : null), _createElement('a', {
                            'className': 'product-link d-flex flex-column text-decoration-none mb-1 pt-2',
                            'href': this.url
                        }, _createElement('p', mergeProps({ 'className': 'product-title overflow-hidden text-secondary' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('p', { 'className': 'product-price-container mb-0' }, this.on_sale ? _createElement('s', {
                            'className': 'text-secondary mr-2',
                            'key': '4168'
                        }, this.formatPrice(this.compare_at_price)) : null, _createElement('span', { 'className': 'product-price ' + (this.compare_at_price && this.compare_at_price ? 'text-primary' : 'text-secondary') }, this.price_varies ? _createElement('span', { 'key': '4422' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '))), _createElement('div', {
                            'className': 'product-list-add-to-cart',
                            'data-product-url': this.url
                        }, this.variant_ids.length === 1 ? [_createElement('form', {
                                'method': 'post',
                                'action': '/cart/add',
                                'id': 'product_form_' + this.id,
                                'acceptCharset': 'UTF-8',
                                'className': 'shopify-product-form',
                                'encType': 'multipart/form-data',
                                'data-product-id': this.id,
                                'data-variants': true,
                                'key': '47241'
                            }, _createElement('input', {
                                'type': 'hidden',
                                'name': 'form_type',
                                'value': 'product'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'utf8',
                                'value': '\u2713'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'id',
                                'value': this.variant_ids[0]
                            }), _createElement('button', {
                                'type': 'submit',
                                'className': 'add-to-cart-btn btn btn-outline-primary btn-skewed px-2 py-1 px-lg-3 py-lg-2',
                                'disabled': this.out_of_stock ? true : false
                            }, _createElement('span', {
                                'className': 'add-to-cart-btn-spinner spinner-border spinner-border-sm mr-2 mb-1',
                                'role': 'status',
                                'aria-hidden': 'true',
                                'style': {
                                    display: 'none',
                                    transform: 'none'
                                }
                            }), _createElement('span', { 'className': 'add-to-cart-btn-text' }, '\n            ', this.out_of_stock ? _translate(`product_out_of_stock`) : this.stock && (this.stock?.includes('Available') && !this.stock?.includes('In-stock Only')) ? 'Special Order' : _translate(`product_add_to_cart`), '\n          ')))] : null, this.variant_ids.length > 1 ? [
                            ,
                            window.themeSettings.quick_view_enabled === 'true' ? _createElement('div', {
                                'className': 'btn-quick-view-wrapper',
                                'key': '60133'
                            }, _createElement('button', {
                                'className': 'btn-quick-view btn btn-outline-primary btn-skewed px-2 py-1 px-lg-3 py-lg-2',
                                'data-product-url': this.url,
                                'disabled': this.out_of_stock ? true : false
                            }, _createElement('span', {
                                'className': 'btn-quick-view-spinner spinner-border spinner-border-sm mr-2 mb-1',
                                'role': 'status',
                                'aria-hidden': 'true',
                                'style': {
                                    display: 'none',
                                    transform: 'none'
                                }
                            }), _createElement('span', { 'className': 'btn-quick-view-text' }, '\n            ', this.out_of_stock ? _translate(`product_out_of_stock`) : this.stock && (this.stock?.includes('Available') && !this.stock?.includes('In-stock Only')) ? 'Special Order' : _translate(`product_select_options`), '\n          '))) : null,
                            ,
                            window.themeSettings.quick_view_enabled === 'false' ? _createElement('button', {
                                'className': 'add-to-cart-btn btn btn-outline-primary btn-skewed px-2 py-1 px-lg-3 py-lg-2',
                                'href': this.url,
                                'disabled': this.out_of_stock ? true : false,
                                'key': '60137'
                            }, _createElement('span', {
                                'className': 'add-to-cart-btn-spinner spinner-border spinner-border-sm mr-2 mb-1',
                                'role': 'status',
                                'aria-hidden': 'true',
                                'style': {
                                    display: 'none',
                                    transform: 'none'
                                }
                            }), _createElement('span', { 'className': 'add-to-cart-btn-text' }, '\n          ', this.out_of_stock ? _translate(`product_out_of_stock`) : this.stock && (this.stock?.includes('Available') && !this.stock?.includes('In-stock Only')) ? 'Special Order' : _translate(`product_select_options`), '\n        ')) : null
                        ] : null), this.price ? _createElement('p', {
                            'className': 'affirm-as-low-as mt-1 mb-0',
                            'data-amount': this.price * 100,
                            'data-affirm-type': 'logo',
                            'data-affirm-color': 'blue',
                            'key': '7768'
                        }) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_SearchResult' }, _createElement.apply(this, [
                'div',
                { 'className': 'product-list list-unstyled row row-cols-2 row-cols-md-3 row-cols-lg-3 mb-5 mx-0' + (this.view ? ` ${ this.view }` : '') + ' cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.message(function () {
                    return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                            'href': 'mailto:support@convermax.com',
                            'className': 'cm_message-link'
                        }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                            'className': 'cm_message__incompatible',
                            'key': '8800'
                        }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                            'className': 'cm_message__nothing-for-vehicle',
                            'key': '10670'
                        }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'href': this.searchByVehicleUrl
                        }, _translate(`message_view_compatible_products`)))] : null, this.universalFitResults ? [_createElement('div', {
                            'className': 'cm_message__universal-results',
                            'key': '13900'
                        }, _translate(`message_universal_fit_results`))] : null, this.template === 'badRequest' ? _createElement('div', {
                        'className': 'cmTemplate_badRequest',
                        'key': '1545'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver
                    }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '18340' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '19210' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '20040' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '17974' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                        'className': 'cmTemplate_corrected',
                        'key': '2167'
                    }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                        originalQuery: this.
                        originalQuery, 
                        query
                    : this.
                        query
                     }))) : null, this.template === 'networkError' ? _createElement('div', {
                        'className': 'cmTemplate_networkError',
                        'key': '2334'
                    }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '25160' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '26030' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '26860' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '24794' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'nothing' ? _createElement('div', {
                        'className': 'cmTemplate_nothing',
                        'key': '2849'
                    }, _createElement('div', {}, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver,
                        'key': '2973'
                    }, _translate(`message_reset_search`)) : null)) : null, this.template === 'partial' ? _createElement('div', {
                        'className': 'cmTemplate_partial',
                        'key': '3168'
                    }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                        'className': 'cmTemplate_timeout',
                        'key': '3322'
                    }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                        'className': 'cmTemplate_unknown',
                        'key': '3562'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '38410' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '39280' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '40110' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '38044' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], [this.loadMore(function () {
                    return _createElement('div', { 'className': 'cm_loadMore' }, _createElement('div', { 'className': 'cm_load-more' }, this.isNotAllItemsReceived ? [
                        this.isActive ? [this.loading] : null,
                        !this.isActive ? [[this.loadMoreButton(function () {
                                    return _createElement('div', {
                                        'className': 'btn-skewed btn btn-primary cm_loadMoreButton',
                                        'onClick': this.activate
                                    }, '\n        ', window.Convermax.config?.loadMoreText || _translate(`load_more`, {  nextPageSize : this. nextPageSize  }), '\n      ');
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null
                    ] : null));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'results',
            items: undefined
        })])));
}
        export const componentNames = ["cm:filterInput","cm:CategoryVehicleWidget","cm:filterInput","cm:FacetBarWheels","cm:filterInput","cm:FacetBarTires","cm:filterChips","cm:filterInput","cm:inputMin","cm:inputMax","cm:Inputs","cm:filterInput","cm:select","cm:inputMin","cm:inputMax","cm:Inputs","cm:facets","cm:FacetPanel","cm:message","cm:customMessage","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:message","cm:loadMoreButton","cm:loadMore","cm:SearchResult"]